<template>
    <div class="app-container">
        <h2><i class="el-icon-s-operation"></i>用户的声音</h2>
        <div class="box">
            <!-- 工具栏 -->
            <h3 class="title">{{source == 'myDemand' ? '提交给我的需求' : '我提交的需求'}}</h3>
            <div class="filter-container">
               <div class="left-filter">
                   <el-input class="filter-item" size="small" clearable v-model="listQuery.search" prefix-icon="el-icon-search" placeholder="搜索需求" style="width: 200px" @keyup.enter.native="handleFilter"></el-input>

                    <div class="filter-item">
                        <span class="demonstration">优先级：</span>
                        <el-select v-model="listQuery.level" size="small" clearable placeholder="请选择">
                            <el-option v-for="item in priorityOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                    <div class="filter-item">
                        <span class="demonstration">需求进度：</span>
                        <el-select v-model="listQuery.status" size="small" clearable placeholder="请选择" @change="handleFilter">
                            <el-option v-for="item in demandOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
               </div>

               <div class="right-filter">
                   <!-- 筛选表头 -->
                   <el-popover width="400" trigger="click">
                        <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:6px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
                        <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
                        </el-checkbox-group>
                    </el-popover>

                    <el-button v-if="source == 'userDemand'" size="mini" icon="el-icon-plus" type="primary" style="margin-left: 10px;" @click="handleAdd">提交需求</el-button>
               </div>
                
            </div>

            <!-- 表格 -->
            <el-table class="grayTableTile" size="mini" :data="tableList" :key="key" v-loading="listLoading"  :default-sort = "{prop: 'createTime', order: 'descending'}" border style="width: 100%"  @sort-change="handleAgeSortChange">

                <el-table-column v-for="(item,index) in tableTheads" :key="index" :prop="Object.keys(item)[0]" :label="item[Object.keys(item)[0]]" sortable='custom' align="center" :min-width="Object.keys(item)[0] == 'level' ? '60px' :'120px'" >
                    <template slot-scope="scope" >
                        <span v-if="Object.keys(item)[0] == 'title'" class="link"  @click="handleEdit(scope.row)">{{ scope.row[Object.keys(item)[0]] }}</span>
                        <span class="mark" v-else-if="Object.keys(item)[0] == 'level'" :class="scope.row[Object.keys(item)[0]] == 1 ? 'one' : scope.row[Object.keys(item)[0]] == 2 ? 'two' : 'three'" >{{scope.row[Object.keys(item)[0]]}}</span>
                        <span v-else-if="Object.keys(item)[0] == 'status'"> {{ scope.row[Object.keys(item)[0]] | statusFilter}}</span>
                         <span v-else-if="Object.keys(item)[0] == 'type'"> {{ scope.row[Object.keys(item)[0]] | typeFilter}}</span>
                        <span v-else> {{ scope.row[Object.keys(item)[0]] }}</span>
                    </template>
                </el-table-column>
        
                <el-table-column label="操作" align="center" min-width="100px">
                    <template slot-scope="scope">
                        <i class="el-icon-edit-outline" style="cursor: pointer; font-size: 20px; color:#1890ff; margin-right:15px;" @click="handleEdit(scope.row)"></i>
                        <i class="el-icon-delete" style="cursor: pointer; font-size: 20px; color:#ff182b" v-if="source == 'userDemand'&& scope.row.status == 4" @click="handleDelete(scope.row)"></i>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize"  />

        </div>

        <!-- 创建，编辑需求 -->
        <Dialog ref="demand" :source="source" @renewList="getList"></Dialog>

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Dialog from './dialog'
import {ajax_userdemand, ajax_mydemand, ajax_demandDelete} from '@Demand~/api/demand'
import { arrSlice, sortKeys } from '@/filters'

const defaultFormTheadMy = [
    {systemType: '所属产品'},
    {level: '优先级'},
    {productName: '所属游戏'},
    {menuName: '菜单'},
    {kpiName: '模块'},
    {title: '需求标题'},
    {type: '需求类型'},
    {userName: '提交人'},
    {createTime: '提交时间'},
    {status: '需求进度'}
]

const defaultFormTheadUser = [
    {systemType: '所属产品'},
    {level: '优先级'},
    {productName: '所属游戏'},
    {menuName: '菜单'},
    {kpiName: '模块'},
    {title: '需求标题'},
    {type: '需求类型'},
    {completeUserName: '反馈人'},
    {createTime: '提交时间'},
    {status: '需求进度'}
]

export default {
    props: {
        source:{
            type: String,
            default: '',
            required: true
        }
    },
    components:{Pagination, Dialog},
    data() {
        return {
            listQuery: {
                search: '', // 搜索需求
                level: '', // 优先级
                status: '', // 需求进度
                pageNo: 1,
                pageSize: 10,
            },

            priorityOptions: [{id:1,name:'P1'},{id:2,name:'P2'},{id:3,name:'P3'}], // 优先级选项
            demandOptions:[{id:0, name:'评估中'},{id:1, name:'已规划'},{id:2, name:'开发中'},{id: 3, name:'已发布'},{id:4, name:'已关闭'}],

            originalCaseTable:[], // 排序原始数据
            caseTable: [], // 存放后端一次性返回的所有数据
            handCaseTable: [], // 存放处理假分页后的数据(等距切割)
            tableData: [], // 切割后页面应展示的数据
            key: 1, // table key

            listLoading: false,
            total: 0,

            checkboxTitle: this.source == 'myDemand' ? defaultFormTheadMy : defaultFormTheadUser,
            tableTheadOptions: this.source == 'myDemand' ? defaultFormTheadMy : defaultFormTheadUser,
            tableTheads:this.source == 'myDemand' ? defaultFormTheadMy : defaultFormTheadUser,

        }
    },
    filters: {
        // 需求进度
        statusFilter(status) {
            const statusMap = {
                0: '评估中',
                1: '已规划',
                2: '已开发',
                3: '已发布',
                4: '已关闭',
                '-1':'已删除'
            }
            return statusMap[status]
        },

        // 需求类型
        typeFilter(type) {
            const typeMap = {
                0: '其他',
                1: '数据异常',
                2: '产品优化',
                3: '功能BUG',
                4: '平台异常',
            }
            return typeMap[type]
        },
    },
    created() {
        this.getList()

    },
    watch: {
        // 筛选表头
        checkboxTitle(valArr) {
            console.log('表头：',valArr)
            this.tableTheads = this.tableTheadOptions.filter(i => valArr.indexOf(i) >= 0)
            this.key = this.key + 1
        }
    },
    computed: {
        // 模糊查询表格
        tableList() {
            const search = this.listQuery.search
            const level = this.listQuery.level
            let caseTable = this.caseTable
            if(search) {
                caseTable = this.caseTable.filter(data => {
                    // return Object.keys(data).some(key => {
                        if(level) {
                            return String(data['title']).toLowerCase().indexOf(search) > -1 && data['level'] == level
                        } else {
                            return String(data['title']).toLowerCase().indexOf(search) > -1 
                        }
                    // })
                })

            } else {
                caseTable =  this.caseTable.filter(data => {
                    if(level) {
                        return data['level'] == level
                    } else {
                        return data
                    }
                }) 
            }

            // console.log(this.total)

            this.total = caseTable.length
            // 将一维数组切割成二维数组
            this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
            this.tableData = this.handCaseTable[this.listQuery.pageNo-1]
            return this.tableData
        }
    },
    methods: {

        // 获取数据
        getList() {
            this.listLoading = true;
            if(this.source == 'userDemand') {
                // 我提交的需求
                ajax_userdemand(this.listQuery.status).then(response => {
                    this.listLoading = false
                    if(response.code == 1) {
                        this.caseTable = response.data
                        this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
                    } 
                })
            } else {
                // 提交给我的需求
                ajax_mydemand(this.listQuery.status).then(response => {
                    this.listLoading = false
                    if(response.code == 1) {
                        this.caseTable = response.data
                        this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
                    }
                })
            }          
        },

         // 监听排序变化
        handleAgeSortChange(e) {
            console.log(e)
            if(e.order) {
                const order = e.order == 'descending' ? true : false
                this.caseTable.sort(sortKeys(e.prop, order))
            } else {
                this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
            }
        },

        // 搜索
        handleFilter() {
            this.listQuery.pageNo = 1
            this.getList()
        },

        // 创建（提交）需求
        handleAdd() {
            this.$refs['demand'].addInit()
        },

        // 编辑需求
        handleEdit(row) {
            this.$refs['demand'].editInit(row)
        },

        // 删除需求
        handleDelete(row) {
            this.$confirm('删除后需求不可恢复，您确定要删除这个需求吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ajax_demandDelete(row.id).then(response => {
                    if(response.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });

                        this.getList()
                    }
                })
               
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }

    }
}
</script>

<style lang="scss" scoped>
    h2{
        margin-top: 0;
        font-weight: 700;
        font-style: normal;
        color: #666666;
        font-size: 24px;
        padding: 0 10px;
        i{
            color: #63d1ff;
            margin-right: 5px;
        }
    }
    .box{
        border: 10px solid #f2f2f2;
        padding: 15px;
        .title{
            margin-top: 0;
            font-weight: 400;
            font-style: normal;
            font-size: 18px;
            color: #333333;
        }
        .filter-container{
            padding: 0 15px 6px;
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;
        }
        .link{
            cursor: pointer;
            color: #1890ff;
        }
        .mark{
            display: inline-block;
            font-weight: 700;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 17px;
        }
        .one{
            color: #FF0000;
            border: 2px solid #FF0000;
            border-radius: 100%;
        }
        .two{
            color: #ffcc66;
            border: 2px solid #ffcc66;
            border-radius: 100%;
        }
        .three{
            color: #5DCFFF;
            border: 2px solid #5DCFFF;
            border-radius: 100%;
        }

    }
</style>